exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component-fade-enter-active[data-v-21c452ac],.component-fade-leave-active[data-v-21c452ac]{transition:opacity .3s ease}.component-fade-enter[data-v-21c452ac],.component-fade-leave-to[data-v-21c452ac]{opacity:0}.navbar-crm[data-v-21c452ac]{background:#e9e9e9;background:-moz-linear-gradient(top,#e9e9e9 0,#ddd 100%);background:-webkit-linear-gradient(top,#e9e9e9,#ddd);background:linear-gradient(180deg,#e9e9e9 0,#ddd);border-bottom:1px solid #ddd}.navbar-crm__title[data-v-21c452ac]{margin-right:2rem}.navbar-light .navbar-nav .active>.nav-link[data-v-21c452ac],.navbar-light .navbar-nav .nav-link.active[data-v-21c452ac],.navbar-light .navbar-nav .nav-link.show[data-v-21c452ac],.navbar-light .navbar-nav .show>.nav-link[data-v-21c452ac]{color:#ff6200}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-21c452ac&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/Navbar.vue
// module id = 220
// module chunks = 0